import { alpha, Box, Button, InputBase, Paper, styled } from "@mui/material";
import React, { useMemo, useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { generateShippingServiceColumns } from "./helper";
import DataTableComponent from "../../../components/common/DataTable/DataTable";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { useSelector, useDispatch } from "react-redux";
import { setShippingServices, resetShippingServiceState } from "../../../store/shippingServiceSlice";
import { useToastMessages } from "../../../lib/messages/useToastMessages";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "12px",
  backgroundColor: "#FAFAFA",
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  // width: "230px",
  height: "40px",
  [theme.breakpoints.up("sm")]: {
    // marginLeft: theme.spacing(1),
    // width: "auto",
  },
  border: "1px solid #EEEEEE",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "230px",
    // [theme.breakpoints.up("sm")]: {
    //   width: "12ch",
    //   "&:focus": {
    //     width: "20ch",
    //   },
    // },
  },
}));

export default function ShippingServiceList() {
  const [searchValue, setSearchValue] = useState("");
  const shippingServices = useSelector(state => state.shippingService.shippingServices);
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const toast = useToastMessages();

  useEffect(() => {
    const fetchShippingServices = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "shippingServices"));
        const services = [];
        querySnapshot.forEach((doc) => {
          services.push({ ...doc.data(), id: doc.id });
        });
        dispatch(setShippingServices(services));
      } catch (error) {
        console.error("Error fetching shipping services:", error);
      }
    };
    fetchShippingServices();
  }, [dispatch]);

  const handleDelete = async (row) => {
    try {
      await deleteDoc(doc(db, "shippingServices", row.id));
      dispatch(setShippingServices(shippingServices.filter(s => s.id !== row.id)));
      toast.Success("Shipping service deleted successfully!");
    } catch (error) {
      toast.Error("Failed to delete shipping service.");
      console.error("Failed to delete shipping service:", error);
    }
  };

  const menuOptions = useMemo(
    () => [
      {
        id: "Edit",
        iconName: "mdi:square-edit-outline",
        actionName: "Edit",
        onClickHandle: (row) => {
          navigation(`/shipping/shipping-service/edit/${row.id}`);
        },
      },
      {
        id: "Delete",
        iconName: "material-symbols:delete-rounded",
        actionName: "Delete",
        onClickHandle: handleDelete,
      },
      {
        id: "view-details",
        iconName: "ic:baseline-remove-red-eye",
        actionName: "View Details",
        onClickHandle: (row) => {
          navigation(`/shipping/shipping-service/view/${row?.id}`);
        },
      },
    ],
    [navigation, shippingServices]
  );
  const adminColumns = generateShippingServiceColumns(menuOptions);
  const filteredRows = shippingServices?.filter((row) => {
    const includesTerm = row.wareHouseDetails?.warehouseName
    ?.toLowerCase()
    .includes(searchValue.toLowerCase());
    return includesTerm;
  });
  console.log(filteredRows,"filteredRowsads")

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ p: "24px 16px", paddingLeft: "0px" }}>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ "aria-label": "search" }}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </Search>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#5E17EB",
                color: "#fff",
                border: "1px solid #5E17EB",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#fff",
                  backgroundColor: "#5E17EB",
                },
              }}
              onClick={() => {
                dispatch(resetShippingServiceState());
                navigation("addNew");
              }}
            >
              Add Shipping Source
            </Button>
          </Box>
        </Box>
      </Box>
      {filteredRows?.length > 0 && (
        <Box sx={{ display: "contents" }}>
          <Paper
            sx={{
              width: "100%",
              // height: "75vh",
              border: "1px solid #E5E5E8",
              borderRadius: "4px",
            }}
          >
            <DataTableComponent
              data={filteredRows || []}
              columns={adminColumns}
              // searchHandler={searchHandler}
              // paginationHandler={paginationHandler}
              // pagination={pagination}
            />
          </Paper>
        </Box>
      )}
    </>
  );
}
